// Module
var code = "<!--ko with: _component--> <!--ko template: {html: $data.GetTemplate.bind($data), afterRender: $data.AfterRender.bind($data)}--><!--/ko--> <!--/ko-->";
// Exports
export default code;